import React, { useEffect, useRef } from "react";

const VideoToFrameContainer: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <div
      id="videoFramer"
      className="videoToFrameContainer"
      style={{
        position: "absolute",
        left: "-9999px",
        width: "1px",
        height: "1px",
        visibility: "hidden",
      }}
    >
      <video
        ref={videoRef}
        muted
        preload="metadata"
        playsInline
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default VideoToFrameContainer;
